export const T = {
  en_GB: {
    addPortfolio: "Add Portfolio",
    removePortfolio: "Remove portfolio",
    maxPortfolios: "A goal can have at most 5 portfolios.",
    cannotDeleteLast: "A goal must keep at least one portfolio.",
    deletePortfolioTitle: "Delete Portfolio",
    deletePortfolioDescription:
      "Are you sure you want to delete this portfolio? This action cannot be undone.",
    delete: "Delete",
    cancel: "Cancel",
    loading: "Loading portfolios…",
    portfolioFallback: "Portfolio",
  },
  nb_NO: {
    addPortfolio: "Legg til portefølje",
    removePortfolio: "Fjern portefølje",
    maxPortfolios: "Et mål kan ha maks 5 porteføljer.",
    cannotDeleteLast: "Et mål må ha minst én portefølje.",
    deletePortfolioTitle: "Slett portefølje",
    deletePortfolioDescription:
      "Er du sikker på at du vil slette denne porteføljen? Denne handlingen kan ikke angres.",
    delete: "Slett",
    cancel: "Avbryt",
    loading: "Laster porteføljer…",
    portfolioFallback: "Portefølje",
  },
} as const;
